export const LODGING_CHECKBOX_PARAM = 'analytics_lodging_checkbox_active';

/**
 * Parse Mobility lodging-checkbox state from search URL query params.
 * @param {URLSearchParams|string} queryParams - Query string or URLSearchParams instance.
 * @returns {boolean|null} Parsed value, or null when absent/invalid.
 */
export function parseLodgingCheckboxParam(queryParams) {
  const params =
    typeof queryParams === 'string'
      ? new URLSearchParams(queryParams.startsWith('?') ? queryParams.slice(1) : queryParams)
      : queryParams;

  if (!params.has(LODGING_CHECKBOX_PARAM)) {
    return null;
  }

  const value = params.get(LODGING_CHECKBOX_PARAM);
  if (value === 'true') return true;
  if (value === 'false') return false;
  return null;
}

/**
 * Build Mixpanel purchase props from persisted lodging-checkbox session state.
 * @param {boolean|null|undefined} active - Redux lodgingCheckboxSession.active value.
 * @returns {object} `{ lodging_checkbox_active }` when set, otherwise empty object.
 */
export function serializeLodgingCheckboxProps(active) {
  if (active === true || active === false) {
    return { lodging_checkbox_active: active };
  }

  return {};
}
